export default __webpack_public_path__ + "static/e2d37f34-6bca-473c-b64d-93811f4dc046-c9834c378c2e0463bf08b505edad6153.woff2";